/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-checkbox-layout[_ngcontent-%COMP%]{white-space:normal;text-align:left;margin-top:8px}.mat-checkbox-layout[_ngcontent-%COMP%]   .mat-checkbox-label[_ngcontent-%COMP%]{font-size:14px;line-height:18px}.edit-category-btn[_ngcontent-%COMP%]{position:absolute;left:108px;color:#365899;cursor:pointer;text-decoration:underline;z-index:9}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/manually.add/create.place/create.place.component.scss.shim.ngstyle.js.pre-build-optimizer.js